export default __webpack_public_path__ + "static/media/icon-pycharm.1f6dd5f4.svg";